import { render, staticRenderFns } from "./space-stats-list.vue?vue&type=template&id=5b042e90&scoped=true"
import script from "./space-stats-list.vue?vue&type=script&lang=js"
export * from "./space-stats-list.vue?vue&type=script&lang=js"
import style0 from "./space-stats-list.vue?vue&type=style&index=0&id=5b042e90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b042e90",
  null
  
)

export default component.exports